module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Epub4211-5.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "PN-I",
    attrs: {
      "id": "toc_marker-6"
    }
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("for")])]), _vm._v(" "), _c('p', {
    staticClass: "CT-with-Date-below para-style-override-8"
  }, [_c('span', {
    staticClass: "char-style-override-9"
  }, [_vm._v("G")]), _c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("ore Vidal")])]), _vm._v(" "), _c('p', {
    staticClass: "Date-below-CT para-style-override-9"
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("1925–2012")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_vm._v("Who helped kick me into shape.")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_vm._v("The planet has lost its ")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_vm._v("most barbed critic. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_vm._v("The job of world-class ")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-1"
  }, [_vm._v("pain-in-the-arse is now vacant.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-047e7078","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Epub42115.vue
// module id = 75
// module chunks = 0